import { getActions } from 'apprise-core/action'
import { manageCategories, TagCategory } from 'apprise-core/category'
import { useOracle } from 'apprise-frontend-iam/authz/oracle'


export const useTagOracle = () => {

    const actions = getActions()
    const oracle = useOracle()

    const can = {

        manageAll: () => oracle.can(manageCategories),
        manage: (category: TagCategory) => oracle.can(actions.specialise(manageCategories, category.id))

    }


    const self = {

        canAdd: can.manageAll

        ,

        canRemove: (category?: TagCategory | undefined) => category ? can.manage(category) : can.manageAll()

        ,

        canEdit: (category: TagCategory | undefined) =>  category ? can.manage(category) : can.manageAll()

    }


    return self
}
